/**
 * Canonical doodle canvas dimensions. Wire stroke coordinates are authored
 * against these exact pixel dimensions, so the editor canvas, the read-only
 * preview, and the PNG rasterizer MUST all render at the same size or the
 * strokes land in the wrong place. Import this constant everywhere instead of
 * repeating the 800/500 literals.
 */
export const DOODLE_CANVAS = { width: 800, height: 500 } as const;

/**
 * The doodle canvas background (and the color the eraser paints with). The
 * eraser is not a true "clear to transparent" — it paints the background color
 * back over strokes, and the flood-fill seeds its target color off this white
 * background. So this single constant is the coupling point for three behaviors:
 * the initial fillRect, the eraser fill color, and the flood-fill start color.
 */
export const DOODLE_CANVAS_BG = '#ffffff';
